module.exports = __webpack_public_path__ + "img/ktsImg.59a494e4.jpg";